import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filter:["Scoreboard", "Job Finder", "Book Store", "Flight Booking", "Product Cart", "Blog Application"],
    searchKeyword: ''
};

 const taskSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        toggleFilter: (state, action) => {
          const  selectedKeyword = state.filter.find((item) => item === action.payload);

          if(selectedKeyword){
            state.filter = state.filter.filter((item) => item !== action.payload)
          }

          if(!selectedKeyword){
            state.filter.push(action.payload);
          }
        },
        searchTask: (state, action) => {
          state.searchKeyword = action.payload;
        }
    }

})

export const {toggleFilter, searchTask} = taskSlice.actions;
export default taskSlice.reducer;